import './../stylesheets/workers';

import * as kenAllComponent from './components/ken_all';
import * as fileFieldComponent from './components/file_field';
import * as callapseComponent from './components/collapse';
import * as formComponent from './components/form';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // 住所のアクション
  kenAllComponent.setAdrresEvent();
  // ファイルフィールドのアクション
  fileFieldComponent.selectFileFieldActions();
  fileFieldComponent.selectFileAfterActions();
  fileFieldComponent.cancelSelectFile();
  fileFieldComponent.destroySelectFile();
  // アコーディオンのアクション
  callapseComponent.toggleCollapse();
  // フォームのアクション
  formComponent.temporarilySave();
})